import { memo, useCallback, useMemo } from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import type { ITableSearchProps } from "@components/molecules/tableSearch/types";
import { FastInput } from "@components/fastFields";
import { SearchFormConfig } from "@components/molecules/tableSearch/schema";

export const TableSearch = memo(function TableSearch({
  value,
  onChange,
  placeholder = "default",
}: ITableSearchProps) {
  const formConfig = useMemo(() => {
    return SearchFormConfig();
  }, []);

  const { t } = useTranslation("tableSearch");

  const formik = useFormik({
    ...formConfig,
    initialValues: { search: value || formConfig?.initialValues?.search },
    enableReinitialize: true,
  });

  const onInputChange = useCallback(
    (value: string) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <form
      className={classes.search}
      onSubmit={(event) => event.preventDefault()}
    >
      <FastInput
        name={"search"}
        type={"search"}
        formik={formik}
        placeholder={t(placeholder)}
        onChange={onInputChange}
        noLabel
      />
    </form>
  );
});
